import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'product-sync-api-component',
  templateUrl: './product-sync-api.component.html',
  styleUrls: ['./product-sync-api.component.scss'],
})
export class ProductSyncApiComponent implements OnInit {
  logoImg: string = `../../../assets/imgs/logo/se2in_logo.png`;
  titleSectionProp: any = {
    class: 'iq-title-box-2',
    title: 'SYNC_API_HEADER',
    description: 'SYNC_API_DESCRIPTION',
  };
  constructor(
    public translate: TranslateService,
    public route: ActivatedRoute
  ) {}
  List: any[] = [
    { title: 'JAVA_8_COMPATIBLE' },
    { title: 'MAVEN_ARTEFACT' },
    { title: 'OWN_PERSISTENCE_LAYER' },
    { title: 'OPEN_SOURCE' },
  ];
  List1: any[] = [
    { title: 'Apps', content: '', timer: 500, currentValue: 0, symbol: '+' },
    {
      title: 'Downloads',
      content: 'k',
      timer: 100,
      currentValue: 0,
      symbol: '+',
    },
  ];
  List2: any[] = [
    {
      title: 'Syncs',
      content: 'm',
      timer: 35,
      currentValue: 0,
      symbol: '+',
    },
    {
      title: 'DATABASES',
      content: 'k',
      timer: 15,
      currentValue: 0,
      symbol: '+',
    },
  ];
  designer: any[] = [
    {
      title: 'DESIGNER',
      desc: 'description',
      class: 'creative design windows',
      download: 'DOWNLOAD',
      downloadType: [
        '.exe (Windows)',
        '.zip (Windows)',
        '.exe (Windows ARM64)',
      ],
      downloadTypeActive: '.exe (Windows)',
      trial: 'TRIAL',
    },
    {
      title: 'DESIGNER',
      desc: 'description',
      class: 'creative design macos',
      download: 'DOWNLOAD',
      downloadType: ['.dmg (Apple Silicon)', '.dmg (Intel)'],
      downloadTypeActive: '.dmg (Apple Silicon)',
      trial: 'Free 30-day trial',
      infobox: 'INFOBOX',
    },
    {
      title: 'DESIGNER',
      desc: 'description',
      class: 'creative design linux',
      download: 'DOWNLOAD',
      downloadType: ['.tar.gz (Linux)', '.tar.gz (Linux ARM64)'],
      downloadTypeActive: '.tar.gz (Linux)',
      trial: 'Free 30-day trial',
    },
  ];
  creator: any[] = [
    {
      title: 'CREATOR',
      desc: 'description',
      class: 'creative design windows',
      download: 'DOWNLOAD',
      downloadType: [
        '.exe (Windows)',
        '.zip (Windows)',
        '.exe (Windows ARM64)',
      ],
      downloadTypeActive: '.exe (Windows)',
      trial: 'TRIAL',
    },
    {
      title: 'CREATOR',
      desc: 'description',
      class: 'creative design macos',
      download: 'DOWNLOAD',
      downloadType: ['.dmg (Apple Silicon)', '.dmg (Intel)'],
      downloadTypeActive: '.dmg (Apple Silicon)',
      trial: 'Free 30-day trial',
      infobox: 'INFOBOX',
    },
    {
      title: 'CREATOR',
      desc: 'description',
      class: 'creative design linux',
      download: 'DOWNLOAD',
      downloadType: ['.tar.gz (Linux)', '.tar.gz (Linux ARM64)'],
      downloadTypeActive: '.tar.gz (Linux)',
      trial: 'Free 30-day trial',
    },
  ];
  backoffice: any[] = [
    {
      title: 'BACKOFFICE',
      desc: 'description',
      class: 'creative design windows',
      download: 'DOWNLOAD',
      downloadType: [
        '.exe (Windows)',
        '.zip (Windows)',
        '.exe (Windows ARM64)',
      ],
      downloadTypeActive: '.exe (Windows)',
      trial: 'TRIAL',
    },
    {
      title: 'BACKOFFICE',
      desc: 'description',
      class: 'creative design macos',
      download: 'DOWNLOAD',
      downloadType: ['.dmg (Apple Silicon)', '.dmg (Intel)'],
      downloadTypeActive: '.dmg (Apple Silicon)',
      trial: 'Free 30-day trial',
      infobox: 'INFOBOX',
    },
    {
      title: 'BACKOFFICE',
      desc: 'description',
      class: 'creative design linux',
      download: 'DOWNLOAD',
      downloadType: ['.tar.gz (Linux)', '.tar.gz (Linux ARM64)'],
      downloadTypeActive: '.tar.gz (Linux)',
      trial: 'Free 30-day trial',
    },
  ];
  se2syncApi: any[] = [
    {
      title: 'PRODUCT_SYNC_API',
      desc: 'description',
      class: 'creative design windows',
      download: 'DOWNLOAD',
      downloadType: [
        '.exe (Windows)',
        '.zip (Windows)',
        '.exe (Windows ARM64)',
      ],
      downloadTypeActive: '.exe (Windows)',
      trial: 'TRIAL',
    },
    {
      title: 'PRODUCT_SYNC_API',
      desc: 'description',
      class: 'creative design macos',
      download: 'DOWNLOAD',
      downloadType: ['.dmg (Apple Silicon)', '.dmg (Intel)'],
      downloadTypeActive: '.dmg (Apple Silicon)',
      trial: 'Free 30-day trial',
      infobox: 'INFOBOX',
    },
    {
      title: 'PRODUCT_SYNC_API',
      desc: 'description',
      class: 'creative design linux',
      download: 'DOWNLOAD',
      downloadType: ['.tar.gz (Linux)', '.tar.gz (Linux ARM64)'],
      downloadTypeActive: '.tar.gz (Linux)',
      trial: 'Free 30-day trial',
    },
  ];
  se2syncManager: any[] = [
    {
      title: 'PRODUCT_SYNC_CREATOR_MODE_FALSE',
      desc: 'description',
      class: 'creative design windows',
      download: 'DOWNLOAD',
      downloadType: [
        '.exe (Windows)',
        '.zip (Windows)',
        '.exe (Windows ARM64)',
      ],
      downloadTypeActive: '.exe (Windows)',
      trial: 'TRIAL',
    },
    {
      title: 'PRODUCT_SYNC_CREATOR_MODE_FALSE',
      desc: 'description',
      class: 'creative design macos',
      download: 'DOWNLOAD',
      downloadType: ['.dmg (Apple Silicon)', '.dmg (Intel)'],
      downloadTypeActive: '.dmg (Apple Silicon)',
      trial: 'Free 30-day trial',
      infobox: 'INFOBOX',
    },
    {
      title: 'PRODUCT_SYNC_CREATOR_MODE_FALSE',
      desc: 'description',
      class: 'creative design linux',
      download: 'DOWNLOAD',
      downloadType: ['.tar.gz (Linux)', '.tar.gz (Linux ARM64)'],
      downloadTypeActive: '.tar.gz (Linux)',
      trial: 'Free 30-day trial',
    },
  ];

  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    const duration = 5000;
    const intervalTime = 100;
    const steps = duration / intervalTime;
    [...this.List1, ...this.List2].forEach((list) => {
      const increment = list.timer / steps;
      let currentValue = 0;
      const interval = setInterval(() => {
        currentValue += increment;
        list.currentValue = currentValue;
        if (currentValue >= list.timer) {
          currentValue = list.timer;
          clearInterval(interval);
        }
        list.currentValue = Math.floor(currentValue);
      }, intervalTime);
    });
  }
}
